import r from"./descriptors.js";import t from"./fails.js";var e=r,o=t,a=e&&o(function(){return Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype!=42});export{a as default};
